import React, { useState } from 'react'

import { Tabs, Button, Divider, Descriptions } from 'antd'

import {
  CreditCardOutlined,
  DollarOutlined,
  ImportOutlined,
  FolderOpenOutlined
} from '@ant-design/icons'

import { useHistory, Link } from 'react-router-dom'
import { useFetch, useCreateEventNotAvailable, useDismissEvent, usePutPaymentMethod, useRejectPrices, useCancelPaymentMethod } from '../../../../hooks/vendor/user/show'
import { useStorage, isStorageAvailable } from '../../../../hooks/common/storage'
import Profile from '../../../../core/components/profile'
import BannerNotAvailable from '../../../../components/event/banner/notAvailable'
import FormNotAvailable from '../../../../components/event/form/notAvailableV2'
import VendorInformation from '../../../../components/vendor/profile/information'
import VendorDetails from '../../../../components/vendor/profile/details'

import PriceList from '../../../../components/price/list'
import PaymentMethod from '../../../../components/payment/methodV2'

import FileManager from './files'

import { LAYOUT_VENDOR_USER_EDIT } from '../../navigation'
import Loader from '../../../../components/loader'

const { TabPane } = Tabs

const Show = (props) => {
  const history = useHistory()
  const onPressBack = () => history.goBack()

  const { data, isLoading, isError } = useFetch()
  const { data: storageData, isLoading: isStorageLoading, isError: isStorageError } = useStorage()
  const { mutate: createEventNotAvailable, isLoading: isCreateEventLoading } = useCreateEventNotAvailable()
  const { mutate: dismissEvent, isLoading: isDismissEventLoading } = useDismissEvent()
  const { mutate: updatePaymentMethod, isLoading: isUpdatePaymentLoading } = usePutPaymentMethod()
  const { mutate: rejectPrices, isLoading: isRejectPricesLoading } = useRejectPrices()
  const { mutate: cancelPaymentMethod, isLoading: isCancelPaymentMethodLoadig } = useCancelPaymentMethod()

  const [modalVisible, setModalVisible] = useState(false)
  const showModal = () => setModalVisible(true)
  const hideModal = () => setModalVisible(false)

  const actionLoading = isCreateEventLoading || isDismissEventLoading || isUpdatePaymentLoading || isRejectPricesLoading || isCancelPaymentMethodLoadig

  if (isLoading || isStorageLoading) {
    return (<Loader loading />)
  }
  if (isError || isStorageError) {
    return null
  }

  const storageAvailable = isStorageAvailable(storageData)

  const { vendor, events } = data

  return (
    <>
      <BannerNotAvailable vendor events={events || []} dismissEvent={dismissEvent} />

      <Profile
        onBack={onPressBack}
        mainTitle='Settings'
        ainSubtitle='subtitle'
        mainExtra={[
          <Button key='ooo' type='default' size='small' icon={<ImportOutlined />} onClick={showModal}>
            Not Available
          </Button>,
          <Link key='1' to={LAYOUT_VENDOR_USER_EDIT}>
            <Button type='primary' size='small'>
              <i className='fa fa-pencil-square-o' />
              <Divider type='vertical' />
              Update
            </Button>
          </Link>
        ]}
        renderInformation={() => <VendorInformation vendor={vendor} />}
      >
        <VendorDetails vendor={vendor} />

        <Tabs defaultActiveKey='prices' size='small' style={{ marginBottom: 32, marginTop: 32 }}>
          <TabPane
            tab={
              <span>
                {' '}
                <DollarOutlined /> Basic Prices{' '}
              </span>
            }
            key='prices'
            style={{ minHeight: 400 }}
          >
            <Descriptions size='medium' column={1}>
              <Descriptions.Item label='Currency'>
                {data.vendor.currency ? data.vendor.currency.name : ''}
              </Descriptions.Item>
              <Descriptions.Item label='Rush fee percent'>
                {' '}
                {parseFloat(data.vendor.rush_percent).toFixed(0) + '%'}{' '}
              </Descriptions.Item>
            </Descriptions>
            <br />
            <PriceList
              prices={vendor.prices}
              pricesReview={vendor.prices_review}
              cancelPrices={rejectPrices}
            />
          </TabPane>

          <TabPane
            tab={
              <span>
                {' '}
                <CreditCardOutlined /> Payment Methods{' '}
              </span>
            }
            key='payment'
            style={{ minHeight: 400 }}
          >
            <PaymentMethod
              vendor={data.vendor}
              updatePaymentMethod={updatePaymentMethod}
              cancelChanges={cancelPaymentMethod}
            />
          </TabPane>

          {storageAvailable && (
            <TabPane
              tab={
                <span>
                  {' '}
                  <FolderOpenOutlined /> Files{' '}
                </span>
              }
              key='files'
              style={{ minHeight: 400 }}
            >
              <FileManager
                id={vendor.id}
                storage={vendor.storage_public}
                defaults={storageData.defaults}
              />
            </TabPane>
          )}
        </Tabs>
        {modalVisible && (
          <FormNotAvailable
            createEventNotAvailable={createEventNotAvailable}
            onCancel={hideModal}
            modalVisible={modalVisible}
          />
        )}
      </Profile>
    </>
  )
}

export default Show
